var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowZigzagRight18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4a1 1 0 0 0 0 2h7.586l-6.293 6.293A1 1 0 0 0 4 14h9.956l-1.618 1.564a.844.844 0 0 0 1.192 1.193l3.223-3.115a.842.842 0 0 0 .247-.617v-.02l-.001-.043a.841.841 0 0 0-.247-.6l-3.223-3.115a.842.842 0 1 0-1.192 1.193L13.95 12H6.414l6.293-6.293A1 1 0 0 0 12 4H2z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGQ9Ik0yIDRhMSAxIDAgMCAwIDAgMmg3LjU4NmwtNi4yOTMgNi4yOTNBMSAxIDAgMCAwIDQgMTRoOS45NTZsLTEuNjE4IDEuNTY0YS44NDQuODQ0IDAgMCAwIDEuMTkyIDEuMTkzbDMuMjIzLTMuMTE1YS44NDIuODQyIDAgMCAwIC4yNDctLjYxN3YtLjAybC0uMDAxLS4wNDNhLjg0MS44NDEgMCAwIDAtLjI0Ny0uNmwtMy4yMjMtMy4xMTVhLjg0Mi44NDIgMCAxIDAtMS4xOTIgMS4xOTNMMTMuOTUgMTJINi40MTRsNi4yOTMtNi4yOTNBMSAxIDAgMCAwIDEyIDRIMnoiLz48L3N2Zz4=";
export { SvgArrowZigzagRight18 as ReactComponent };